var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"score-collapse",class:{
    expand: _vm.isExpand,
    'has-hover': _vm.hasHover
  }},[_c('div',{staticClass:"collapse-header",class:{ expand: _vm.isExpand, 'has-expand': _vm.hasExpand },on:{"click":_vm.changeExpand}},[_vm._t("header"),(_vm.hasExpand)?_c('img',{staticClass:"header-img",attrs:{"src":require("@/assets/arrow-select.svg"),"alt":""}}):_vm._e()],2),_c('div',{staticClass:"collapse-body",class:{ expand: _vm.isExpand }},[_c('div',{staticClass:"transition-container"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }